// import goat2 from './assets/goat2.png'
// import goat1 from './assets/goat1.png'
// import goat3 from './assets/goat3.png'
// import goat4 from './assets/goat4.png'
// import goat5 from './assets/goat5.png'
import goat6 from './assets/goat6.png'
import goat10 from './assets/goat10.png'
import baseModelBG from './assets/baseModelBG.png'
import baseBG from './assets/baseBG.png'
import goatFrontPage from './assets/goatFrontPage.png'
import './MintComponent.css'
import { useState } from 'react'
import { ethers, BigNumber } from 'ethers'
import NSGG from './assets/NSGG.json'

const nsggNFTAddress = "0x1ffa754c2BD705bF5853De96E06BAfF6de6137AD"
// update in code below too.

const MintComponent = ({ accounts, setAccounts }) => {
    const [mintAmount, setMintAmount] = useState(1);
    const isConnected = Boolean(accounts[0]);

    async function handleMint() {
        if (window.ethereum) {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const contract = new ethers.Contract(
                nsggNFTAddress,
                NSGG.abi,
                signer
            );
            try {
                const response = await contract.mint(BigNumber.from(mintAmount), { value: ethers.utils.parseEther((0.00 * mintAmount).toString()) });
                window.alert("Response : Success! \n" + response)
            } catch (err) {
                window.alert("Error : Something went wrong. \n" + err.reason)
            }
        }
    }

    // const handleDecrement = () => {
    //     if (mintAmount <= 1) return;
    //     setMintAmount(mintAmount - 1);
    // }
    // const handleIncrement = () => {
    //     if (mintAmount >= 5) return;
    //     setMintAmount(mintAmount + 1);
    // }

    return (
        <div className=''>
            <div className='imageDiv img-fluid px-0 pb-4'>
                <img className='d-block d-lg-none' src={goat10} alt="goat" />
                <img className='d-none d-lg-block' src={goat6} alt="goat" />
                <img className='d-lg-block d-none' src={goatFrontPage} alt="goat2" />

            </div>
            <div className="row">
                <div className='col-lg-5 col-12'>
                    <h2>WELCOME TO THE <br />BORED GOATS</h2>
                </div>

                <div className="paraDiv col-lg-8 col-12 pt-lg-3 pt-2 justify-content-center">
                    <p>Bored Goats is a unique hand-drawn collection of 3,333 GOAT NFTs that roam on the Ethereum blockchain. Each holder of a Bored Goat grants affiliation to an exclusive community that provides access to a members-only discord server and more to come in the near-future. Stay GOATED.
                    </p>
                </div>
                <hr className='pb-4' />


                <div className='mintCard row'>
                    <div className='col-lg-4 col-12 mintCardContent text-uppercas'>Buy A Goat</div>
                    <div className='col-12 col-lg-4 px-4 supplyDiv'>The initial sale has sold out. To get your Bored Ape, check out the collection on OpenSea.</div>

                    <div className='col-lg-4 col-12 buttonContainer'>


                        <div className='col-lg-12 col-12 mintBtnDiv'>
                            <button><a href="https://opensea.io/collection/boredgoats-v">Buy from Opensea</a></button>
                        </div>
                    </div>
                </div>
            </div>
            <hr className='pb-4' />
            <div className='proof pt-5'>
                <h3 className='pb-4'>The Process of Our Hand-Drawn NFTs</h3>
                <div className='proofContainer pb-5'>
                    <div className='proofDetails d-lg-block d-none'>
                        <div className='row'>
                            <div className='col-6'>
                                {/* <div className='col-12 desc py-3'>First we chose the base model as shown:</div> */}
                                <div className='col-6 col-lg-6 proofDetailsImg'>
                                    <img src={baseBG} alt='base' />
                                </div>
                            </div>
                            <div className='col-6'>
                                {/* <div className='col-12 desc py-3'>Then, the traits were hand drawn on the base model : </div> */}
                                <div className='col-6 col-lg-6 proofDetailsImg'>
                                    <img src={baseModelBG} alt='baseModel' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='proofDetails d-lg-none d-block'>
                        <img className='col-12 py-3' src={baseBG} alt='base' />
                        <img className='col-12 py-3' src={baseModelBG} alt='baseModel' />
                    </div>
                </div>
            </div>
            <hr className='pb-4' />
            <div className='mintinginfo'>
                <h3>FAQs</h3>
                <div className='row'>
                    <div className='col-lg-6 col-12'>
                        <p className='question'>What is the mint price?</p>
                        <p className='answers'>Free Now.</p>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <p className='question'>When is mint?</p>
                        <p className='answers'>June 5<sup>th</sup></p>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-6 col-12'>
                        <p className='question'>What's the mint limit per wallet?</p>
                        <p className='answers'>There will be a maximum of 2 NFTs per wallet for the first 1,000 NFTs and a maximum of 5 NFTs per wallet for the remainder of 2,333.</p>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <p className='question'>What's the supply?</p>
                        <p className='answers'>3,333</p>
                    </div>
                </div>

            </div>
            <hr className='pb-4 mt-4 d-lg-block d-none' />
        </div >
    );
}

export default MintComponent;
